<template>
    <div class="mainDiv">

    <el-form  ref="queryCondition" :model="queryCondition">
      <el-row >
        <el-col :span="5">
          出票人员
          <el-select size="mini" v-model="queryCondition.userId" clearable placeholder="请选择" class="dialogDataWidth"  style="width: 60%;">
            <el-option v-for="item in userSelectedIdList" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="10">出票日期
          <el-date-picker size="mini" v-model="queryCondition.currentDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-col>

        <el-col :span="4" >
          <el-button type="primary" size="mini" @click='query' icon="el-icon-search">查询</el-button>
          <el-button type="success" plain size="mini" v-print="printOption" icon="el-icon-printer">打印</el-button>

        </el-col>
      </el-row>

    </el-form>
     <!-- <el-scrollbar style="height:100%"> -->
      <section id="printMe" style="margin-top:20px;" ref="printMe">
        <el-row>
          <el-col :span="8">
            出票日期：{{this.queryCondition.currentDate}}
          </el-col>
          <el-col :span="8">
            出票人员：{{this.realname}}
          </el-col>
          <el-col :span="8">
            主管签字：___________
          </el-col>
        </el-row>
        <el-row>
            <el-divider content-position="left">汇总</el-divider>
            <el-table class="el-table" stripe size="mini" :data="totalContent" align="center" style="margin-top: 10px;" header-row-class-name="tableHeader">
              <el-table-column align='center' prop="pay_type" label="支付方式" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
              <el-table-column align='center' prop="person_num" label="总人数" label-class-name="greenLabel"></el-table-column>
              <el-table-column align='center' prop="total_price" label="总价(元)"  label-class-name="greenLabel"></el-table-column>
            </el-table>
        </el-row>

        <el-row>
          <el-divider content-position="left">现金支付</el-divider>
          <el-table class="el-table" stripe size="mini" :data="cashContent" align="center" style="margin-top: 10px;" header-row-class-name="tableHeader">
            <el-table-column align='center' prop="pay_type" label="支付方式" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="ticket_type" label="票种" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="person_num" label="可用人数" label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="unit_price" label="单价(元)"  label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="total_price" label="总价(元)"  label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="user_name" label="出票人" label-class-name="greenLabel"></el-table-column>
          </el-table>
        </el-row>
        <el-row>
          <el-divider content-position="left">聚合支付</el-divider>
          <el-table class="el-table" stripe size="mini" :data="payContent" align="center" style="margin-top: 10px;" header-row-class-name="tableHeader">
            <el-table-column align='center' prop="pay_type" label="支付方式" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="ticket_type" label="票种" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="person_num" label="可用人数" label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="unit_price" label="单价(元)"  label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="total_price" label="总价(元)"  label-class-name="greenLabel"></el-table-column>
            <el-table-column align='center' prop="user_name" label="出票人" label-class-name="greenLabel"></el-table-column>
          </el-table>
        </el-row>
      </section>
     <!-- </el-scrollbar> -->

     <div id="printDiv" style="width:100vw"></div>
    </div>
</template>
<script>

  export default {
    name: 'printMe',
    mounted: function () {
      this.selectUser();
      this.type_option = this.CommonUtil.getCodeList('ticket_type');
      this.queryCondition.currentDate = this.DateUtil.getCurrentDate();
      this.query();
    },
    data() {
      return {
        msg: 'this is printMe',
        userSelectedIdList: [],
        realname: '所有人',
        queryCondition: {
          currentDate: '',
          userId: '',
        },
        totalContent: [],
        cashContent: [],
        payContent: [],
        printOption: {
					id: 'printDiv', // 打印元素的id 不需要携带#号
					popTitle: '' // 页眉标题 默认浏览器标题 空字符串时显示undefined 使用html语言
				},
      }
    },
    methods: {
      //状态改成汉字
      formatStr(row, column) {
        if(column.property == 'ticket_type'){
          return this.CommonUtil.getCodeValue('ticket_type', row.ticket_type);
        }else if(column.property == 'pay_type'){
          return this.CommonUtil.getCodeValue('pay_type', row.pay_type);
        }else{
          return this.CommonUtil.getCodeValue('ticket_from', row.ticket_from);
        }
      },
      print: function(){
        var newWindow=window.open("打印窗口","_blank");
        var docStr = this.$refs.printMe.innerHTML;
        
        newWindow.document.write(docStr);
        var styles=document.createElement("style");
        styles.setAttribute('type','text/css');//media="print"
        newWindow.document.getElementsByTagName('head')[0].appendChild(styles);
        newWindow.print();
        newWindow.close();
      },
      // 查询按钮
      query: function () {
        var url = '/ticket/today';
        url += "?currentDate=" + this.queryCondition.currentDate;
        if(this.queryCondition.userId != "" && this.queryCondition.userId != null){
          url += '&createUserId=' + this.queryCondition.userId;
          for(var i=0;i<this.userSelectedIdList.length;i++){
            if(this.userSelectedIdList[i].id == this.queryCondition.userId){
              this.realname = this.userSelectedIdList[i].realname;
            }
          }
          
        }else{
          this.realname = '所有人';
        }
        this.$axios.get(url).then(res => {
          this.totalContent = res.data.total;
          this.cashContent = res.data.cash;
          this.payContent = res.data.pay;
          // this.printDiv();
          setTimeout(this.printDiv, 500);
        })
      },
      printDiv(){
          // console.log(this.$refs.printMe.innerHTML)
          document.getElementById('printDiv').innerHTML = '';
          document.getElementById('printDiv').innerHTML = this.$refs.printMe.innerHTML;
      },
      reset: function () {
        this.queryCondition.createDate = [];
        this.queryCondition.userId = '';
        this.queryCondition.ticketType = '';
        this.$refs.queryCondition.resetFields();
        this.query();
      },
      
      /**
       * 给角色选人
       */
      selectUser(){
        this.$axios.get('/user/getUserListByRole/3').then(response => {
          this.userSelectedIdList = response.data;
        })
      },
      
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/check/today.vue